import { InternalAPI } from "@/powerups/InternalAPI";
import { WBState, WhiteboardData } from "./stateInterfaceType";
import mutations from "./mutations";

type AppContext = {
  state: WBState;
  commit(k: keyof typeof mutations, ...args: unknown[]): void;
};

export default {
  setWBMetadata(context: AppContext, metadata: Partial<WhiteboardData>) {
    context.commit("setWBMetadata", metadata);
    InternalAPI.whiteboard.updateWBMetadataImmediately(
      context.state.whiteboard.wbid,
      metadata
    );
  },
};
